import type { ActivityFilterParams, TimeseriesParams } from "./api/types";

export const qk = {
  contents: (id: string | null) => ["contents", id ?? "root"] as const,
  me: ["auth", "me"] as const,
  activityOverview: ["activity", "overview"] as const,
  activityList: (params: ActivityFilterParams) => ["activity", "list", params] as const,
  activityByUser: (userId: string) => ["activity", "by-user", userId] as const,
  activityByFile: (fileId: string) => ["activity", "by-file", fileId] as const,
  activityTimeseries: (params: TimeseriesParams) => ["activity", "timeseries", params] as const,
};
